import type { IntlShape } from 'react-intl';
import type { LocalizedTextProps } from '../components/LocalizedText/LocalizedText';

/**
 * Prepares placeholders by localizing special placeholders (category_string and format_string).
 *
 * @param placeholders - The original placeholders object
 * @param intl - The react-intl IntlShape object containing formatMessage function
 * @returns The prepared placeholders object with localized special placeholders
 */
export const preparePlaceholders = (
  placeholders: LocalizedTextProps['placeholders'],
  intl: IntlShape,
): Record<string, string> => {
  const categoryString = placeholders?.category_string ? intl.formatMessage({ id: placeholders.category_string }) : '';
  const formatString = placeholders?.format_string ? intl.formatMessage({ id: placeholders.format_string }) : '';

  return {
    ...placeholders,
    ...(categoryString && {
      category_string: categoryString,
    }),
    ...(formatString && {
      format_string: formatString,
    }),
  };
};
